import React from "react";
import { Button, Text } from "@chakra-ui/react";

const DEFAULT_COLOR = "#331F12";
const DEFAULT_BG = "#F5B241";
const defaultShadow = "0 0 0 2px #331F12";

const ButtonSpoleto = ({ children, color, bg, shadow, ...rest }) => {
  const background = bg || DEFAULT_BG;
  const fontColor = color || DEFAULT_COLOR;
  const boxShadow = shadow || defaultShadow;
  return (
    <Button
      bg={background}
      color={fontColor}
      borderRadius="5px"
      width="100%"
      maxWidth="100%"
      fontSize="24px"
      fontFamily="JosefinSemiBold"
      display="flex"
      alignItems="center"
      justifyContent="center"
      py={8}
      _hover={{
        opacity: "0.8",
      }}
      _focus={{
        boxShadow,
      }}
      _active={{
        boxShadow: "0",
        opacity: "0.5",
      }}
      {...rest}
    >
      <Text pos="relative" top="2px">
        {children}
      </Text>
    </Button>
  );
};

export default ButtonSpoleto;
